import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import CampaignLists from '../../../components/reports/Campaign/CampaignLists'

import OrderInvoiceDetailReport from '../../../components/reports/telephony/SelectedTelephoneyList/OrderInvoiceDetailReport'
import CampaignDispositionReport from '../../../components/reports/telephony/SelectedTelephoneyList/CampaignDispositionReport'
import CampaignLeadReport from '../../../components/reports/telephony/SelectedTelephoneyList/CampaignLeadReport'

// report components
import OrderInvoiceDetailReport1 from '../../../components/reports/telephony/SelectedTelephoneyList/OrderInvoiceDetailReport1'
import CampaignDispositionReport1 from '../../../components/reports/telephony/SelectedTelephoneyList/CampaignDispositionReport1'
import CampaignLeadReport1 from '../../../components/reports/telephony/SelectedTelephoneyList/CampaignLeadReport1'

const CampaignRoute = () => {
    const tenant = localStorage.getItem('circleone-user')?.toLowerCase()
    const isMdIndia = tenant === 'mdindia' || tenant === 'stage' || tenant === 'victorinox' || tenant === 'cslfinance' || tenant === 'knabfinance' || tenant === 'mdindiadcinvoice' ||  tenant === 'csquare' || tenant === 'payswiffibl' || tenant === 'payswiffstage' || tenant === 'briezi' ;

    return (
        <Routes>

            <Route
                path='/reports-list'
                element={
                    <>
                        <CampaignLists />
                    </>
                }
            />
            <Route
                path='/campaign-deatil-report'
                element={
                    isMdIndia ? <OrderInvoiceDetailReport /> : <OrderInvoiceDetailReport1 />
                }
            />
            <Route
                path='/disposition-report'
                element={
                    isMdIndia ? <CampaignDispositionReport /> : <CampaignDispositionReport1 />
                }
            />
            <Route
                path='/campaign-lead-report'
                element={
                    isMdIndia ? <CampaignLeadReport /> : <CampaignLeadReport1 />
                }
            />

            <Route index element={<Navigate to='/campaign/reports-list' />} />

        </Routes >
    )
}

export default CampaignRoute
